import { createListenerMiddleware } from "@reduxjs/toolkit";
import { stopSession, startSession, endActivity } from "./thunks";
import { processSuccess, updateActivity } from "./activitySlice";
import { ActivityStatuses } from "./constants";

const dataEnteringListenerMiddleware = createListenerMiddleware();

dataEnteringListenerMiddleware.startListening({
    actionCreator: stopSession.fulfilled,
    effect: async (_, listenerApi) => {
        listenerApi.dispatch(startSession());
    },
});

dataEnteringListenerMiddleware.startListening({
    actionCreator: processSuccess,
    effect: async (_, listenerApi) => {
        listenerApi.dispatch(endActivity());
    },
});

dataEnteringListenerMiddleware.startListening({
    actionCreator: updateActivity,
    effect: async (action, listenerApi) => {
        if (action.payload.status === ActivityStatuses.SKIPPED) {
            listenerApi.dispatch(endActivity());
        }
    },
});

export default dataEnteringListenerMiddleware;
